// REACT
import React, { Component } from "react";

// I18N
import { translate } from "react-i18next";

// SHARED
import Settings from "../../shared/settings";

// MOMENT
import moment from "moment";

// AXIOS
import axios from "axios";

//GOOGLE GEOCODER
import Geocode from "react-geocode";

// GRID
import { Container, Row, Col } from "react-grid-system";

// LIGHTEN
import { lighten } from "polished";

// SELECT
import Select from "react-select";

// MODAL
import Modal from "react-responsive-modal";
import "react-responsive-modal/lib/react-responsive-modal.css";

// ICONS
import FaClose from "react-icons/lib/fa/close";
import MdClear from "react-icons/lib/md/clear";
import MdCheck from "react-icons/lib/md/check";
import MdErrorOutline from "react-icons/lib/md/error-outline";

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";
import "./apply.page.css";

// COMPONENTS
import CheckBox from "../../components/checkbox/checkbox";
import Timer from "../../components/applyTimer/applyTimer.component";
import Input from "../../components/apply/input/input";
import Radio from "../../components/apply/radio/radio";
// import Social from "../../components/apply/social/social";
import TextArea from "../../components/apply/textarea/textarea";
import Other from "../../components/apply/other/other";
import FileUploader from "../../components/FileUploader/FileUploader";
import Videos from "../../components/videos/videos";
import BannerTop from "../../components/bannertop/bannertop.component";
import Loading from "../../components/loading/loading.component";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

//PDF
import RulesDoc from "../../assets/docs/Regulamento_TASTEPORTUGAL.pdf";
import AgreementDoc from "../../assets/docs/Declaracao_de_consentimento_de_dados_pessoais_TASTEPORTUGAL.pdf";
import politicPTDOC from "../../../src/assets/docs/politicPTDOC.pdf";

class Apply extends Component {
  constructor(props) {
    super(props);

    let { t } = props;

    this.state = {
      status: 0,
      size: 30,
      listOfCountries:[],
      isOpen: false,
      isOpenError: false,
      agreement: false,
      data: {
        0: {
          pais: {
            id: 0,
            title: t("apply_country_title"),
            keyName: "country_id",
            placeholder: "Selecione o país",
            name: "pais",
            required: true,
            selected: false,
            data: [],
            value: null,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        1: {
          cidade: {
            id: 1,
            title: "Cidade",
            keyName: "city",
            placeholder: "Selecione a cidade",
            name: "cidade",
            required: true,
            selected: false,
            data: [],
            value: null,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        2: {
          nomeFirma: {
            id: 2,
            title: "Nome da firma",
            keyName: "company_name",
            placeholder: "Insira o nome da firma",
            name: "nomeFirma",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 50,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        3: {
          designacao: {
            id: 3,
            title: "Designação comercial do estabelecimento",
            keyName: "name",
            placeholder: "Insira a designação comercial do estabelecimento",
            name: "designacao",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 200,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        4: {
          morada: {
            id: 4,
            title: "Morada do estabelecimento",
            keyName: "address",
            placeholder: "Insira a morada do estabelecimento",
            name: "morada",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 200,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        5: {
          localidade: {
            id: 5,
            title: "Localidade",
            placeholder: "Insira a localidade",
            keyName: "localidade",
            name: "localidade",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        6: {
          codigoPostal: {
            id: 6,
            title: "Código Postal",
            placeholder: "Insira o código postal",
            keyName: "codigoPostal",
            name: "codigoPostal",
            type: "text",
            required: true,
            value: null,
            min: 4,
            max: 10,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        7: {
          telefone: {
            id: 7,
            title: "Telefone",
            keyName: "contact",
            placeholder: "Insira o número de telefone",
            type: "number",
            name: "telefone",
            required: true,
            value: null,
            min: 9,
            max: 15,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        8: {
          fax: {
            id: 8,
            title: "Fax",
            keyName: "fax",
            placeholder: "Insira o número de fax",
            name: "fax",
            type: "number",
            required: false,
            value: null,
            min: 9,
            max: 15,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        9: {
          responsavel: {
            id: 9,
            title: "Nome do responsável ou proprietário",
            keyName: "company_owner",
            placeholder: "Insira o nome do responsável ou proprietário",
            name: "responsavel",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        10: {
          naturalidade: {
            id: 10,
            title: "Naturalidade do responsável ou proprietário",
            keyName: "owner_nacionality",
            placeholder: "Insira a naturalidade do responsável ou proprietário",
            name: "naturalidade",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        11: {
          estabelecimento: {
            id: 11,
            title: "Possui mais estabelecimentos de restauração?",
            keyName: "has_multiple_restaurants",
            name: "estabelecimento",
            required: true,
            value: "nao",
            isValid: true,
          },
        },
        12: {
          email: {
            id: 12,
            title: "E-mail do responsável",
            keyName: "owner_email",
            placeholder: "Insira o e-mail do responsável",
            name: "email",
            type: "email",
            required: true,
            value: null,
            min: 3,
            max: 40,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        13: {
          telefoneResponsavel: {
            id: 13,
            title: "Telemóvel/Telefone do responsável",
            keyName: "owner_contact",
            placeholder: "Insira o telemóvel/telefone do responsável",
            name: "telefoneResponsavel",
            type: "number",
            required: true,
            value: null,
            min: 9,
            max: 15,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        14: {
          socio: {
            id: 14,
            title: "Associado da AHRESP?",
            keyName: "ahresp_partner",
            name: "socio",
            required: false,
            value: "nao",
            isValid: true,
          },
        },
        15: {
          tipoEstabelecimento: {
            id: 15,
            title: "Tipo de estabelecimento",
            keyName: "typology",
            name: "tipoEstabelecimento",
            required: true,
            error: "",
            message: "",
            isValid: true,
            data: {
              0: {
                id: 3,
                label: t("type_classico"),
                isSelected: false,
              },
              1: {
                id: 4,
                label: t("type_fine_dining"),
                isSelected: false,
              },
              2: {
                id: 5,
                label: t("type_tasca"),
                isSelected: false,
              }
            },
          },
        },
        16: {
          precoMedio: {
            id: 16,
            title: "Preço médio",
            keyName: "price",
            subTitle: " (por pessoa)",
            name: "precoMedio",
            required: true,
            isValid: true,
            data: {
              0: {
                id: 0,
                label: "€, que corresponde a acessível",
                isSelected: true,
              },
              1: {
                id: 1,
                label: "€€, que corresponde a médio",
                isSelected: false,
              },
              2: {
                id: 2,
                label: "€€€, que corresponde a alto",
                isSelected: false,
              },
              3: {
                id: 3,
                label: "€€€€, que corresponde a muito dispendioso",
                isSelected: false,
              },
            },
          },
        },
        17: {
          outrasCaracteristicas: {
            id: 17,
            title: "Outras características do estabelecimento",
            keyName: "features",
            name: "outrasCaracteristicas",
            required: false,
            isValid: "",
            data: {
              0: {
                id: 0,
                label: t("wifi"),
                isSelected: false,
              },
              1: {
                id: 1,
                label: t("baby_chair"),
                isSelected: false,
              },
              2: {
                id: 2,
                label: t("reduced_mob"),
                isSelected: false,
              },
              3: {
                id: 3,
                label: t("reservations"),
                isSelected: false,
              },
              4: {
                id: 4,
                label: t("terrace"),
                isSelected: false,
              },
              5: {
                id: 5,
                label: t("other_caracteristics"),
                isSelected: false,
              },
            },
          },
        },
        18: {
          capacidade: {
            id: 18,
            title: "Capacidade do estabelecimento",
            name: "capacidade",
            required: true,
            isValid: "",
            error: false,
            message: "",
            data: {
              totalInside: {
                label: "Nº total de lugares no interior",
                name: "totalInside",
                number: null,
                keyName: "interior_capacity",
              },
              totalOutside: {
                label: "Nº total de lugares na esplanada",
                name: "totalOutside",
                number: null,
                keyName: "exterior_capacity",
              },
            },
          },
        },
        19: {
          horario: {
            id: 19,
            title: "Horário",
            name: "horario",
            required: true,
            isValid: "",
            error: "",
            message: "",
            days: [
              { id: 0, value: "domingo", label: t("Domingo") },
              { id: 1, value: "segunda", label: t("Segunda") },
              { id: 2, value: "terca", label: t("Terça") },
              { id: 3, value: "quarta", label: t("Quarta") },
              { id: 4, value: "quinta", label: t("Quinta") },
              { id: 5, value: "sexta", label: t("Sexta") },
              { id: 6, value: "sabado", label: t("Sábado") },
              { id: 7, value: "feriados", label: t("Feriados") },
            ],
            data: [
              {
                days: [],
                timeOpen: moment().startOf("day"),
                timeClose: moment().startOf("day"),
                isValidArray: [false, true, true],
              },
            ],
          },
        },
        20: {
          pratosPortugueses: {
            id: 20,
            title:
              "Pratos inspirados na gastronomia portuguesa disponibilizados na carta/menu",
            subTitle: " (indicar os 5 mais caracteristicos)",
            name: "pratosPortugueses",
            required: true,
            error: "",
            message: "",
            isValid: "",
            data: {
              0: {
                name: "",
                isValid: "",
              },
              1: {
                name: "",
                isValid: "",
              },
              2: {
                name: "",
                isValid: "",
              },
              3: {
                name: "",
                isValid: "",
              },
              4: {
                name: "",
                isValid: "",
              },
            },
          },
        },
        21: {
          produtosPortugueses: {
            id: 21,
            title: "Produtos portugueses utilizados",
            subTitle: " (indicar os 10 mais característicos)",
            name: "produtosPortugueses",
            required: false,
            value: [],
            error: "",
            message: "",
            isValid: "",
          },
        },
        22: {
          website: {
            id: 22,
            title: "Website",
            keyName: "website",
            placeholder: "Insira o link do website do estabelecimento",
            name: "website",
            type: "text",
            required: false,
            value: null,
            min: 9,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        23: {
          facebook: {
            id: 23,
            title: "Redes sociais do estabelecimento",
            keyName: "social_fb",
            placeholder: "Insira o link do facebook",
            name: "facebook",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        24: {
          instagram: {
            id: 24,
            title: null,
            keyName: "social_ig",
            placeholder: "Insira o link do instagram",
            name: "instagram",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        25: {
          twitter: {
            id: 25,
            title: null,
            keyName: "social_tw",
            placeholder: "Insira o link do twitter",
            name: "twitter",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        26: {
          sobre: {
            id: 26,
            title: "Sobre o estabelecimento",
            keyName: "about",
            placeholder: "Insira uma pequena descrição sobre o estabelecimento",
            name: "sobre",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 300,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        27: {
          tipoOutro: {
            id: 27,
            title: null,
            placeholder: "Insira outro tipo de estabelecimento",
            keyName: "typology_other",
            name: "tipoOutro",
            type: "text",
            required: false,
            value: null,
            min: 3,
            max: 50,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        28: {
          outrasOutro: {
            id: 28,
            title: null,
            placeholder: "Insira outras características do estabelecimento",
            keyName: "feature_other",
            name: "outrasOutro",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        29: {
          emailEstabelecimento: {
            id: 29,
            title: "E-mail do estabelecimento",
            keyName: "establishment_email",
            placeholder: "Insira o e-mail do estabelecimento",
            name: "emailEstabelecimento",
            type: "email",
            required: true,
            value: null,
            min: 3,
            max: 40,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        30: {
          maisEstabelecimentos: {
            id: 30,
            title:
              "Designação comercial do(s) outro(s) estabelecimento(s) e cidade onde se situa",
            keyName: "establishment_more",
            placeholder:
              "Insira a designação comercial do(s) outro(s) estabelecimento(s) e cidade onde se situa",
            name: "maisEstabelecimentos",
            type: "text",
            required: false,
            value: null,
            min: 3,
            max: 300,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        31: {
          ahresp_partner_number: {
            id: 31,
            title: "Número de associado da AHRESP",
            keyName: "ahresp_partner_number",
            placeholder: "Insira o número de associado da AHRESP",
            name: "ahresp_partner_number",
            type: "number",
            required: false,
            value: null,
            min: 1,
            max: 20,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
      },
      names: [
        "pais",
        "cidade",
        "nomeFirma",
        "designacao",
        "morada",
        "localidade",
        "codigoPostal",
        "telefone",
        "fax",
        "responsavel",
        "naturalidade",
        "estabelecimento",
        "email",
        "telefoneResponsavel",
        "socio",
        "tipoEstabelecimento",
        "precoMedio",
        "outrasCaracteristicas",
        "capacidade",
        "horario",
        "pratosPortugueses",
        "produtosPortugueses",
        "website",
        "facebook",
        "instagram",
        "twitter",
        "sobre",
        "tipoOutro",
        "outrasOutro",
        "emailEstabelecimento",
        "maisEstabelecimentos",
        "ahresp_partner_number",
      ],
      toSend: {
        Restaurant: {
          approved: "0",
          name: null,
          fax: null,
          company_name: null,
          company_owner: null,
          owner_nacionality: null,
          owner_email: null,
          owner_contact: null,
          has_multiple_restaurants: 0,
          ahresp_partner: 0,
          ahresp_partner_number: null,
          translationsStrings: {
            "pt-PT": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
            "en-GB": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
            "fr-FR": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
            "es-ES": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
            "de-DE": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
          },
          network: "1",
          typology: [1],
          meal_types: [],
          interior_capacity: null,
          exterior_capacity: null,
          contact: null,
          price: "1",
          country_id: null,
          city: null,
          address: null,
          coordinates: {
            lat: null,
            lon: null,
          },
          establishment_email: null,
          website: null,
          social_fb: null,
          social_ig: null,
          social_tw: null,
          features: [],
          product_ids: [],
          typology_other: null,
          feature_other: null,
          establishment_more: null,
          images: [],
          urls: [],
        },
        Menu: [],
        Timetable: [],
      },
      images: [],
      statusSend: 1,
      urls: [],
    };
  }

  componentWillUpdate() {
    const requestLang = window.location.pathname.split("/");
    let lang = requestLang[1];

    if (lang !== this.props.i18n.language) {
      let url =
        "/" +
        this.props.i18n.language +
        "/" +
        this.props.t("rede") +
        "/" +
        this.props.t("candidatura");
      this.props.history.replace(url, true);
      this.getCountries();
    }
  }

  componentDidMount() {
    document
      .querySelector("#applyPage")
      .scrollIntoView({ behavior: "smooth", block: "start" });
    this.getCountries();
    Geocode.setApiKey("AIzaSyCopWhPWoTnzTI_IBWXfuo-F3KZothEaaE");
  }

  getCountries = () => {
    const { i18n } = this.props;
    const lang = i18n.language;
    const url =
      Settings.server + "/api/v1/country?expand=translations&lang=" + lang;
    axios
      .get(url)
      .then((res) => {
        const countries = res.data;
        const countriesFormat = [];

        for (let i = 0; i <= countries.length - 1; i++) {
          if (countries[i].name != null && countries[i].name !== "Portugal") {
            if (countries[i].translations.length > 1) {
              for (let e = 0; e <= countries[i].translations.length - 1; e++) {
                const getLang = countries[i].translations[e].lang_id.split("-");

                if (getLang[0] === lang) {
                  countriesFormat.push({
                    country_id: countries[i].translations[e].country_id,
                    value: countries[i].translations[e].name,
                    label: countries[i].translations[e].name,
                    search: countries[i].translations[1].name,
                  });
                }
              }
            }
          }

          if (i === countries.length - 1) {
            countriesFormat.sort((a, b) => {
              return a.value.localeCompare(b.value);
            });

            let dataCopy = JSON.parse(JSON.stringify(this.state.data));
            dataCopy[0].pais.data = countriesFormat;
            this.setState({
              status: 1,
              data: dataCopy,
            });
          }
        }
      })
      .catch((err) => {
        this.setState({
          status: 2,
        });
      });
  };

  formatLang = (lang) => {
    let languages = ["de-DE", "pt-PT", "fr-FR", "es-ES", "en-GB"];

    let matches = languages.filter((value) => {
      return value ? value.substring(0, 2) === lang : false;
    });

    return matches;
  };

  /* SELECIONAR PAÍS */
  selectedCountry = (selected) => {
    if (!selected)
      return;
    const dataCopy = JSON.parse(JSON.stringify(this.state.data));
    const toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));
    toSendCopy.Restaurant.country_id = selected.country_id;
    dataCopy[0].pais.value = selected.value;
    dataCopy[0].pais.isValid = true;
    dataCopy[1].cidade.value = "";
    dataCopy[0].pais.error = "";
    dataCopy[0].pais.message = "";

    this.setState(
      {
        data: dataCopy,
        toSend: toSendCopy,
      },
      async () => {
        await this.getCities(selected.search);
      }
    );
  };

  /* GET CIDADES */
  getCities = async (value) => {
    
    
    await fetch('https://raw.githubusercontent.com/russ666/all-countries-and-cities-json/master/countries.min.json')
      .then(response => response.json())
      .then(data => this.setState({ listOfCountries: data }));
    
    const cities = this.state.listOfCountries[value]; 
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let citiesFormart = [];

    if (cities) {
      cities.forEach((value) => {
        citiesFormart.push({
          value: value,
          label: value,
        });
      });

      if(value === 'France'){
        citiesFormart.push({
          value: 'Strasbourg',
          label: 'Strasbourg',
        })
      }

      citiesFormart.sort((a, b) => {
        return a.value.localeCompare(b.value);
      });

      dataCopy[1].cidade.data = citiesFormart;
    } else {
      dataCopy[1].cidade.data = [];
    }

    this.setState({
      data: dataCopy,
    });
  };

  /* SELECIONAR CIDADE */
  selectCity = (value) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));
    if (value !== null) {
      toSendCopy.Restaurant.city = value.toString();
      dataCopy[1].cidade.value = value;
      dataCopy[1].cidade.isValid = true;
      dataCopy[1].cidade.error = "";
      dataCopy[1].cidade.message = "";
    } else {
      toSendCopy.Restaurant.city = null;
      dataCopy[1].cidade.value = null;
      dataCopy[1].cidade.isValid = "";
      dataCopy[1].cidade.error = "";
      dataCopy[1].cidade.message = "";
    }

    this.setState({
      data: dataCopy,
      toSend: toSendCopy,
    });
  };

  /* VALIDATE TEXT AND NUMBER */
  onBlurValidateTextNumber = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));
    let { t } = this.props;

    if (keyName === "address") {
      if (value) {
        try {
          Geocode.fromAddress(value).then(
            (response) => {
              const { lat, lng } = response.results[0].geometry.location;
              toSendCopy.Restaurant.coordinates.lat = lat;
              toSendCopy.Restaurant.coordinates.lon = lng;
            },
            (error) => {
              console.error(error);
            }
          );
        } catch (error) { }
      }
    }

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern = /^[a-z0-9\u00C0-\u00FF.(),-\s]+$/i;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;

          dataCopy[id][name].value = value.toString();

          if (id !== 5) {
            toSendCopy.Restaurant[keyName] = value.toString();
          }

          this.setState({
            data: dataCopy,
            toSend: toSendCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].isValid = false;
          dataCopy[id][name].message = t("invalid_field");
          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      dataCopy[id][name].value = null;
      if (id !== 5) {
        toSendCopy.Restaurant[keyName] = null;
      }
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE TEXT AND NUMBER AND STRING */
  onBlurValidateSpecialChars = (
    event,
    id,
    keyName,
    required,
    name,
    min,
    max
  ) => {
    let value = event.target.value;

    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    let lang = this.props.i18n.language;
    let formatLang = this.formatLang(lang);

    let { t } = this.props;

    if (keyName === "address") {
      if (value) {
        try {
          Geocode.fromAddress(value).then(
            (response) => {
              const { lat, lng } = response.results[0].geometry.location;
              toSendCopy.Restaurant.coordinates.lat = lat;
              toSendCopy.Restaurant.coordinates.lon = lng;
            },
            (error) => {
              console.error(error);
            }
          );
        } catch (error) { }
      }
    }

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        // dataCopy[id][name].isValid = true;
        // dataCopy[id][name].error = false;

        // toSendCopy.Restaurant.translationsStrings[formatLang][keyName] = value.toString();

        // this.setState({
        //     data: dataCopy,
        //     toSend: toSendCopy
        // })

        dataCopy[id][name].isValid = true;
        dataCopy[id][name].error = false;

        dataCopy[id][name].value = value.toString();

        if (id !== 5) {
          toSendCopy.Restaurant[keyName] = value.toString();
        }

        this.setState({
          data: dataCopy,
          toSend: toSendCopy,
        });
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      toSendCopy.Restaurant.translationsStrings[formatLang][keyName] = null;
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE TEXT AND NUMBER AND STRING */
  onBlurValidateString = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;

    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    let lang = this.props.i18n.language;
    let formatLang = this.formatLang(lang);

    let { t } = this.props;

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern = /^[a-z0-9\u00C0-\u00FF.(),-?!"&\s]+$/i;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;

          toSendCopy.Restaurant.translationsStrings[formatLang][keyName] =
            value.toString();

          this.setState({
            data: dataCopy,
            toSend: toSendCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].isValid = false;
          dataCopy[id][name].message = t("invalid_field");
          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      toSendCopy.Restaurant.translationsStrings[formatLang][keyName] = null;
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE ONLY TEXT */
  onBlurValidateOnlyText = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;

    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    let { t } = this.props;

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern = /^[a-z\u00C0-\u00FF.\s]+$/i;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;
          dataCopy[id][name].value = value.toString();
          if (id !== 5) {
            toSendCopy.Restaurant[keyName] = value.toString();
          }
          this.setState({
            data: dataCopy,
            toSend: toSendCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].message = t("invalid_field");
          dataCopy[id][name].isValid = false;
          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      dataCopy[id][name].value = null;
      if (id !== 5) {
        toSendCopy.Restaurant[keyName] = null;
      }
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE CODEZIP */
  onBlurValidadeCodeZip = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));

    let { t } = this.props;

    let pattern = /^.*$/;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;

          dataCopy[id][name].value = value.toString();
          this.setState({
            data: dataCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].isValid = false;
          dataCopy[id][name].message = t("invalid_field");
          this.setState({
            data: dataCopy,
          });
        }

    if (value.length > 0 || value === '') {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {

      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      dataCopy[id][name].value = null;
      this.setState({
        data: dataCopy,
      });
    }
  };

  onChangePhone = (v) => {
    let value = v;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    if (value === "" || value.length === 0 || value === null) {
      dataCopy[7]["telefone"].error = true;
      dataCopy[7]["telefone"].message = "Campo de preenchimento obrigatório";
    }
    if (value !== "" || value.length !== 0 || value !== null) {
      dataCopy[7]["telefone"].error = false;
      dataCopy[7]["telefone"].success = true;
      dataCopy[7]["telefone"].isValid = true;
      dataCopy[7]["telefone"].message = "";

      dataCopy[7]["telefone"].value = "+" + value.toString();
      toSendCopy.Restaurant["contact"] = "+" + value.toString();

      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  onChangePhoneResponsible = (v) => {
    let value = v;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    if (value === "" || value.length === 0 || value === null) {
      dataCopy[13]["telefoneResponsavel"].error = true;
      dataCopy[13]["telefoneResponsavel"].message =
        "Campo de preenchimento obrigatório";
    }
    if (value !== "" || value.length !== 0 || value !== null) {
      dataCopy[13]["telefoneResponsavel"].error = false;
      dataCopy[13]["telefoneResponsavel"].success = true;
      dataCopy[13]["telefoneResponsavel"].isValid = true;
      dataCopy[13]["telefoneResponsavel"].message = "";

      dataCopy[13]["telefoneResponsavel"].value = "+" + value.toString();
      toSendCopy.Restaurant["owner_contact"] = "+" + value.toString();
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE NUMBER */
  onBlurValidadeNumber = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));
    let { t } = this.props;

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern = /^[0-9]+$/i;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;
          dataCopy[id][name].value = value.toString();
          toSendCopy.Restaurant[keyName] = value.toString();
          this.setState({
            data: dataCopy,
            toSend: toSendCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].isValid = false;
          dataCopy[id][name].message = t("invalid_field");
          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      toSendCopy.Restaurant[keyName] = null;
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE EMAIL */
  onBlurValidadeEmail = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));
    let { t } = this.props;

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;
          toSendCopy.Restaurant[keyName] = value.toString();
          this.setState({
            data: dataCopy,
            toSend: toSendCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].isValid = false;
          dataCopy[id][name].message = t("invalid_field");
          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      toSendCopy.Restaurant[keyName] = null;
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* VALIDATE WEBSITE */
  onBlurValidadeWebsite = (event, id, keyName, required, name, min, max) => {
    let value = event.target.value;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));
    let { t } = this.props;

    if (value.length > 0) {
      if (value.length < min) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message =
          t("min_chars") + " " + min + " " + t("chars");
        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= max + 1) {
        dataCopy[id][name].error = true;
        dataCopy[id][name].success = false;
        dataCopy[id][name].isValid = false;
        dataCopy[id][name].message = t("limit_chars") + "(" + max + ")";
        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern =
          /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w-._~:/?#[\]@!$&'()*+,;=.]+$/gm;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[id][name].isValid = true;
          dataCopy[id][name].error = false;
          toSendCopy.Restaurant[keyName] = value.toString();
          this.setState({
            data: dataCopy,
            toSend: toSendCopy,
          });
        } else {
          dataCopy[id][name].error = true;
          dataCopy[id][name].success = false;
          dataCopy[id][name].isValid = false;
          dataCopy[id][name].message = t("invalid_field");
          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[id][name].error = false;
      dataCopy[id][name].success = false;
      dataCopy[id][name].message = "";
      dataCopy[id][name].isValid = "";
      toSendCopy.Restaurant[keyName] = null;
      this.setState({
        data: dataCopy,
        toSend: toSendCopy,
      });
    }
  };

  /* DEFINIR ESTABELECIMENTO */
  onChangeEstablishment = (value) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    dataCopy[11].estabelecimento.value = value;

    const one = 1;
    const zero = 0;

    if (value === "sim") {
      toSendCopy.Restaurant.has_multiple_restaurants = one.toString();
    } else {
      toSendCopy.Restaurant.has_multiple_restaurants = zero.toString();
    }

    this.setState({
      data: dataCopy,
      toSend: toSendCopy,
    });
  };

  /* DEFINIR SOCIO */
  onChangePartner = (value) => { };

  /* TIPO DE ESTABELECIMENTO */
  typeEstablishment = (id) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    //reverse option
    dataCopy[15].tipoEstabelecimento.data[id].isSelected =
      !dataCopy[15].tipoEstabelecimento.data[id].isSelected;

    //let selected = [];

    Object.values(dataCopy[15].tipoEstabelecimento.data).forEach(
      (value, index) => {
        if (dataCopy[15].tipoEstabelecimento.data[index].isSelected) {
          dataCopy[15].tipoEstabelecimento.data[index].isSelected =
            !dataCopy[15].tipoEstabelecimento.data[index].isSelected;
          //selected.push(index + 1);
        }
      }
    );
    dataCopy[15].tipoEstabelecimento.data[id].isSelected = true;
    this.setState({
      data: dataCopy,
    });

    /* TO DO */
    // if (
    //   dataCopy[15].tipoEstabelecimento.data[0].isSelected === false &&
    //   dataCopy[15].tipoEstabelecimento.data[1].isSelected === false &&
    //   dataCopy[15].tipoEstabelecimento.data[2].isSelected === false &&
    //   dataCopy[15].tipoEstabelecimento.data[3].isSelected === false
    // ) {
    //   dataCopy[15].tipoEstabelecimento.data[0].isSelected = true;
    //   this.setState({
    //     data: dataCopy,
    //   });
    // }
  };

  /* PREÇO MÉDIO */
  averagePrice = (id) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    Object.values(dataCopy[16].precoMedio.data).forEach((value, index) => {
      if (index !== id) {
        dataCopy[16].precoMedio.data[index].isSelected = false;
      } else {
        dataCopy[16].precoMedio.data[id].isSelected = true;
      }
    });

    let sum = id + 1;
    toSendCopy.Restaurant.price = sum.toString();

    this.setState({
      data: dataCopy,
      toSend: toSendCopy,
    });
  };

  /* OUTRAS CARACTERISTICAS DO ESTABELECIMENTO */
  otherFeatures = (id) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));

    dataCopy[17].outrasCaracteristicas.data[id].isSelected =
      !dataCopy[17].outrasCaracteristicas.data[id].isSelected;

    let selected = [];

    Object.values(dataCopy[17].outrasCaracteristicas.data).forEach(
      (value, index) => {
        if (dataCopy[17].outrasCaracteristicas.data[index].isSelected) {
          selected.push(index + 1);
        }
      }
    );

    this.setState({
      data: dataCopy,
    });
  };

  /* CAPACIDADE DO ESTABELECIMENTO */
  defineNumber = (event, to) => {
    let number = event.target.value;

    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    if (number !== "") {
      if (to === 0) {
        dataCopy[18].capacidade.data.totalInside.number = number;
        dataCopy[18].capacidade.isValid = true;
        dataCopy[18].capacidade.error = false;
        dataCopy[18].capacidade.message = "";

        toSendCopy.Restaurant.interior_capacity = number;
      } else {
        dataCopy[18].capacidade.data.totalOutside.number = number;
        dataCopy[18].capacidade.isValid = true;
        toSendCopy.Restaurant.exterior_capacity = number;
      }
    } else {
      if (to === 0) {
        dataCopy[18].capacidade.data.totalInside.number = null;
        dataCopy[18].capacidade.isValid = "";
        dataCopy[18].capacidade.error = true;
        dataCopy[18].capacidade.message = "Campo Obrigatório";

        toSendCopy.Restaurant.interior_capacity = number;
      } else {
        dataCopy[18].capacidade.data.totalOutside.number = null;
        dataCopy[18].capacidade.isValid = "";
        toSendCopy.Restaurant.exterior_capacity = number;
      }
    }
    this.setState({
      data: dataCopy,
      toSend: toSendCopy,
    });
  };

  /* RENDARIZAR HORÁRIO */
  renderShedule = () => {
    const { data } = this.state;

    const { i18n, t } = this.props;

    const content = [];

    data[19].horario.data.map((value, index) => {
      content.push(
        <HorarioRow key={index}>
          <HorarioItem>
            <HorarioSelected>
              <Select
                placeholder={t("SelectDays")}
                clearable={false}
                onChange={(value, id) => this.onChangeSelectDays(value, index)}
                options={data[19].horario.days}
                value={data[19].horario.data[index].days}
                autoBlur={false}
                multi
              />
            </HorarioSelected>
            <HorarioOpen>
              <Timer
                placeholder="Abertura"
                title="Abertura"
                id={index}
                number={1}
                // required={true}
                onChange={this.onChangeTime}
                defaultValue={"00:00 AM"}
                i18n={i18n}
              />
            </HorarioOpen>
            <HorarioClose>
              <Timer
                placeholder="Fecho"
                title="Abertura"
                id={index}
                number={2}
                // required={true}
                onChange={this.onChangeTime}
                defaultValue={"00:00 AM"}
                i18n={i18n}
              />
            </HorarioClose>
            {index !== 0 && (
              <HorarioButton onClick={(id) => this.removeShedule(index)}>
                <FaClose />
              </HorarioButton>
            )}
          </HorarioItem>
        </HorarioRow>
      );
      return true;
    });
    return content;
  };

  /* ADICIONAR LINHA */
  addShedule = () => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let size = dataCopy[19].horario.data.length - 1;

    const add = {
      days: [],
      timeOpen: null,
      timeClose: null,
      isValidArray: [false, true, true],
    };

    if (
      dataCopy[19].horario.data[size].days.length !== 0 &&
      dataCopy[19].horario.data[size].timeOpen !== null &&
      dataCopy[19].horario.data[size].timeClose !== null
    ) {
      dataCopy[19].horario.data = dataCopy[19].horario.data.concat(add);
      this.setState({
        data: dataCopy,
      });
    } else {
      dataCopy[19].horario.error = true;
      dataCopy[19].horario.message =
        "Para adicionar um novo horário primeiro tem que preencher o anterior!";
      this.setState({
        data: dataCopy,
      });
    }
  };

  /* SELECT DAYS */
  onChangeSelectDays = (value, id) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));

    dataCopy[19].horario.data[id].days = value;
    dataCopy[19].horario.error = false;
    dataCopy[19].horario.message = "";

    if (value.length === 0) {
      dataCopy[19].horario.data[id].isValidArray[0] = false;
    } else {
      dataCopy[19].horario.data[id].isValidArray[0] = true;
    }

    this.setState({
      data: dataCopy,
    });
  };

  /* REMOVE SHEDULE */
  removeShedule = (index) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    delete dataCopy[19].horario.data[index];

    dataCopy[19].horario.data.splice(index, 1);
    toSendCopy.Timetable.splice(index, 1);

    this.setState({
      data: dataCopy,
      toSend: toSendCopy,
    });
  };

  /* DEFINIR TEMPO */
  onChangeTime = (value, id, number) => {
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));

    if (number === 1) {
      dataCopy[19].horario.data[id].timeOpen = value;
      dataCopy[19].horario.error = false;
      dataCopy[19].horario.message = "";
      if (value !== "") {
        dataCopy[19].horario.data[id].isValidArray[1] = true;
      } else {
        dataCopy[19].horario.data[id].isValidArray[1] = false;
      }
    } else {
      dataCopy[19].horario.data[id].timeClose = value;
      dataCopy[19].horario.error = false;
      dataCopy[19].horario.message = "";
      if (value !== "") {
        dataCopy[19].horario.data[id].isValidArray[2] = true;
      } else {
        dataCopy[19].horario.data[id].isValidArray[2] = false;
      }
    }
    this.setState({
      data: dataCopy,
    });
  };

  /* PRATOS PORTUGUESES DISPONIBILIZADOS */
  defineDish = (event, index) => {
    let value = event.target.value;
    let number = index + 1;
    let dataCopy = JSON.parse(JSON.stringify(this.state.data));

    if (value.length > 0) {
      if (value.length < 3) {
        dataCopy[20].pratosPortugueses.error = true;
        dataCopy[20].pratosPortugueses.success = false;
        dataCopy[20].pratosPortugueses.message =
          "Tem que inserir no mínimo 3 caracteres no prato número " + number;
        dataCopy[20].pratosPortugueses.data[index].isValid = false;

        this.setState({
          data: dataCopy,
        });
      } else if (value.length >= 200) {
        dataCopy[20].pratosPortugueses.error = true;
        dataCopy[20].pratosPortugueses.success = false;
        dataCopy[20].pratosPortugueses.message =
          "Excede o limite de 200 caracteres no prato número " + number;
        dataCopy[20].pratosPortugueses.data[index].isValid = false;

        this.setState({
          data: dataCopy,
        });
      } else {
        let pattern = /^.+$/i;
        var isValid = pattern.test(value);
        if (isValid) {
          dataCopy[20].pratosPortugueses.data[index].name = value;
          dataCopy[20].pratosPortugueses.data[index].isValid = true;
          dataCopy[20].pratosPortugueses.error = false;

          this.setState({
            data: dataCopy,
          });
        }
      }
    } else {
      dataCopy[20].pratosPortugueses.error = false;
      dataCopy[20].pratosPortugueses.success = false;
      dataCopy[20].pratosPortugueses.message = "";
      dataCopy[20].pratosPortugueses.data[index].isValid = "";

      this.setState({
        data: dataCopy,
      });
    }
  };

  getProducts = (input) => {
    const { i18n } = this.props;

    if (!input) {
      return Promise.resolve({ options: [] });
    }
    return axios
      .get(
        Settings.server +
        "/api/v1/product?lang=" +
        i18n.language +
        "&name=" +
        input
      )
      .then((res) => {
        let options = [];
        res.data.forEach((value) => {
          options.push({
            id: value.id,
            label: value.name,
            value: value.name,
          });
        });
        return { options };
      })
      .catch((err) => { });
  };

  addImages = (ids) => {
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    toSendCopy.Restaurant.images = ids;

    this.setState({
      toSend: toSendCopy,
    });
  };

  onFormSubmit = () => {
    const { data, names } = this.state;
    const lang = this.props.i18n.language;

    let dataCopy = JSON.parse(JSON.stringify(this.state.data));
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    let finalAddress = toSendCopy.Restaurant.address;

    Object.values(data).forEach((value, index) => {
      let to = names[index];



      // TYPOLOGY
      if (index === 15) {
        let selected = [];

        Object.values(value[to].data).forEach((typology, typologyIndex) => {
          if (typologyIndex !== 8) {
            if (typology.isSelected) {
              selected.push(typology.id + 1);
            }
          } else {
            if (typology.isSelected) {
              if (dataCopy[27].tipoOutro.isValid) {
                selected.push(9);
                selected.push(dataCopy[27].tipoOutro.value);
              }
            }
          }
        });

        if (selected.length === 0) {
          dataCopy[15].tipoEstabelecimento.isValid = false;
          dataCopy[15].tipoEstabelecimento.error = true;
          dataCopy[15].tipoEstabelecimento.message = "Campo Obrigatório";
        } else {
          dataCopy[15].tipoEstabelecimento.isValid = true;
          dataCopy[15].tipoEstabelecimento.error = false;
          dataCopy[15].tipoEstabelecimento.message = "";
        }

        // if (totalInside === null || totalInside === "" || totalInside === 0) {
        //   dataCopy[18].capacidade.isValid = false;
        //   dataCopy[18].capacidade.error = true;
        //   dataCopy[18].capacidade.message = "Campo Obrigatório";
        //   toSendCopy.Restaurant.interior_capacity = totalInside;
        // } else {
        //   dataCopy[18].capacidade.isValid = true;
        //   dataCopy[18].capacidade.error = false;
        //   dataCopy[18].capacidade.message = "";
        // }

        toSendCopy.Restaurant.typology = selected;
      }
      // OTHER
      else if (index === 17) {
        let selected = [];

        Object.values(value[to].data).forEach((other, otherIndex) => {
          if (otherIndex !== 8) {
            if (other.isSelected) {
              dataCopy[17].outrasCaracteristicas.isValid = true;
              selected.push(other.id + 1);
            }
          } else {
            if (other.isSelected) {
              if (dataCopy[28].outrasOutro.isValid) {
                dataCopy[17].outrasCaracteristicas.isValid = true;
                selected.push(6);
                selected.push(dataCopy[28].outrasOutro.value);
              }
            }
          }
        });

        toSendCopy.Restaurant.features = selected;
      } else if (index === 18) {
        const totalInside = dataCopy[18].capacidade.data.totalInside.number;

        if (totalInside === null || totalInside === "" || totalInside === 0) {
          dataCopy[18].capacidade.isValid = false;
          dataCopy[18].capacidade.error = true;
          dataCopy[18].capacidade.message = "Campo Obrigatório";
          toSendCopy.Restaurant.interior_capacity = totalInside;
        } else {
          dataCopy[18].capacidade.isValid = true;
          dataCopy[18].capacidade.error = false;
          dataCopy[18].capacidade.message = "";
        }
      }
      // SHEDULE
      else if (index === 19) {
        const shedule = dataCopy[19].horario.data;
        const formatShedule = [];

        if (shedule.length === 1) {
          if (
            shedule[0].days.length > 0 &&
            shedule[0].timeOpen !== null &&
            shedule[0].timeClose !== null
          ) {
            if (
              shedule[0].isValidArray[0] &&
              shedule[0].isValidArray[1] &&
              shedule[0].isValidArray[2]
            ) {
              let days = [];

              Object.values(shedule[0].days).forEach((valueDays, index) => {
                days.push(valueDays.id);
              });

              let open = moment(shedule[0].timeOpen).format("HH:mm");
              let close = moment(shedule[0].timeClose).format("HH:mm");

              formatShedule.push({
                days: days,
                open: open.toString(),
                close: close.toString(),
              });

              toSendCopy.Timetable = formatShedule;
              dataCopy[19].horario.isValid = true;
            } else {
              dataCopy[19].horario.error = true;
              dataCopy[19].horario.message = "Campo inválido!";
              dataCopy[19].horario.isValid = false;
            }
          } else {
            dataCopy[19].horario.error = true;
            dataCopy[19].horario.message = "Campo obrigatório!";
            dataCopy[19].horario.isValid = false;
          }
        } else {
          Object.values(shedule).forEach((value, index) => {
            if (
              value.days.length > 0 &&
              value.timeOpen !== null &&
              value.timeClose !== null
            ) {
              if (
                value.isValidArray[0] &&
                value.isValidArray[1] &&
                value.isValidArray[2]
              ) {
                let days = [];

                Object.values(value.days).forEach((valueDays, index) => {
                  days.push(valueDays.id);
                });

                let open = moment(value.timeOpen).format("HH:mm");
                let close = moment(value.timeClose).format("HH:mm");

                formatShedule.push({
                  days: days,
                  open: open.toString(),
                  close: close.toString(),
                });

                toSendCopy.Timetable = formatShedule;
                dataCopy[19].horario.isValid = true;
              } else {
                dataCopy[19].horario.error = true;
                dataCopy[19].horario.message = "Campo inválido!";
                dataCopy[19].horario.isValid = false;
              }
            }
          });
        }
      }
      // PRATOS
      else if (index === 20) {
        const dishes = dataCopy[20].pratosPortugueses.data;
        let cont = 0;

        const items = Object.values(dishes).filter((item) => item.name === "");

        if (cont !== items.length) {
          dataCopy[20].pratosPortugueses.error = true;
          dataCopy[20].pratosPortugueses.message = "Campo obrigatório!";
        }
        Object.values(dishes).forEach((value, index) => {
          if (value.isValid === true) {
            const existingRecord = toSendCopy.Menu.find(
              (menu) =>
                menu.translationsStrings["pt-PT"].name === value.name.toString()
            );

            if (!existingRecord) {
              toSendCopy.Menu.push({
                translationsStrings: {
                  "pt-PT": {
                    name: lang === "pt" ? value.name.toString() : null,
                    ingredients: null,
                  },
                  "en-GB": {
                    name: lang === "en" ? value.name.toString() : null,
                    ingredients: null,
                  },
                  "de-DE": {
                    name: lang === "de" ? value.name.toString() : null,
                    ingredients: null,
                  },
                  "fr-FR": {
                    name: lang === "fr" ? value.name.toString() : null,
                    ingredients: null,
                  },
                  "es-ES": {
                    name: lang === "es" ? value.name.toString() : null,
                    ingredients: null,
                  },
                },
                price: null,
              });
              cont++;
            }
          }

          if (value.isValid === false) {
            dataCopy[20].pratosPortugueses.error = true;
            dataCopy[20].pratosPortugueses.message = "Campo inválido!";
          }

          if (cont >= 1) {
            dataCopy[20].pratosPortugueses.isValid = true;
          }
        });
      } else {
        if (value[to].required) {
          if (value[to].isValid === true) {
            if (index === 5) {
              if(!finalAddress.includes(value[to].value)){
                const localidade = ", " + value[to].value;
                finalAddress = finalAddress + localidade;
              }
            } else if (index === 6) {
              if(!finalAddress.includes(value[to].value)){
                const code = ", " + value[to].value;
                finalAddress = finalAddress + code;
              }
              toSendCopy.Restaurant.address = finalAddress;
            }
          } else if (value[to].isValid === false) {
            dataCopy[index][to].error = true;
            dataCopy[index][to].message = "Campo inválido!";
            dataCopy[index][to].isValid = false;
          } else {
            dataCopy[index][to].error = true;
            dataCopy[index][to].message = "Campo obrigatório!";
          }
        } else {
          if (value[to].isValid === false) {
            dataCopy[index][to].error = true;
            dataCopy[index][to].message = "Campo inválido!";
            dataCopy[index][to].isValid = false;
          }
        }
      }
    });

    this.setState(
      {
        data: dataCopy,
        toSend: toSendCopy,
      },
      () => {
        const { data, names } = this.state;

        let verify = [];

        Object.values(data).forEach((value, index) => {
          let to = names[index];

          verify.push({
            required: value[to].required,
            isValid: value[to].isValid,
          });
        });

        let format = [];

        verify.forEach((value, index) => {
          if (value.required && value.isValid) {
            format.push(true);
          } else if (value.required && value.isValid === false) {
            format.push(false);
          } else if (value.required && value.isValid === "") {
            format.push(false);
          } else if (value.isValid === true) {
            format.push(true);
          } else {
            format.push("");
          }
        });

        let findFalse = format.indexOf(false);

        if (findFalse === -1) {
          this.formSend();
        } else {
          this.openModal();
          this.setState(
            {
              statusSend: 4,
            },
            () => {
              setTimeout(() => {
                this.closeModal();
                this.setState({
                  statusSend: 0,
                });
              }, 5000);
            }
          );
        }
      }
    );
  };

  formSend = () => {
    this.openModal();
    if (this.state.statusSend !== 2) {
      const url = Settings.server + "/api/v1/restaurant/apply";

      axios
        .post(url, this.state.toSend, {
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        })
        .then((response) => {
          if (response.status >= 200 && response.status < 400) {
            this.setState(
              {
                statusSend: 2,
              },
              () => {
                setTimeout(() => {
                  this.closeModal();
                  this.resetForm();
                }, 5000);
              }
            );
          } else {
            this.setState(
              {
                statusSend: 3,
              },
              () => {
                setTimeout(() => {
                  this.closeModal();
                  this.setState({
                    statusSend: 1,
                  });
                }, 5000);
              }
            );
          }
        })
        .catch((error) => {
          this.setState(
            {
              statusSend: 3,
            },
            () => {
              setTimeout(() => {
                this.closeModal();
                this.setState({
                  statusSend: 1,
                });
              }, 5000);
            }
          );
        });
    } else {
      setTimeout(() => {
        this.closeModal();
        this.setState({
          statusSend: 1,
        });
      }, 5000);
    }
  };

  openModal = () => {
    this.setState({
      isOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      isOpen: false,
    });
  };

  openModalError = () => {
    this.setState(
      {
        isOpenError: true,
      },
      () => {
        setTimeout(() => {
          this.closeModalError();
        }, 10000);
      }
    );
  };

  closeModalError = () => {
    this.setState({
      isOpenError: false,
    });
  };

  getUrls = (urls) => {
    let toSendCopy = JSON.parse(JSON.stringify(this.state.toSend));

    let format = [];

    urls.forEach((value) => {
      format.push(value.url);
    });

    toSendCopy.Restaurant.urls = format;

    this.setState({
      toSend: toSendCopy,
    });
  };

  resetForm = () => {
    const options = this.state.data[0].pais.data;
    let { t } = this.props;
    this.setState({
      data: {
        0: {
          pais: {
            id: 0,
            title: t("apply_country_title"),
            keyName: "country_id",
            placeholder: "Selecione o país",
            name: "pais",
            required: true,
            selected: false,
            data: options,
            value: null,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        1: {
          cidade: {
            id: 1,
            title: "Cidade",
            keyName: "city",
            placeholder: "Selecione a cidade",
            name: "cidade",
            required: true,
            selected: false,
            data: [],
            value: null,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        2: {
          nomeFirma: {
            id: 2,
            title: "Nome da firma",
            keyName: "company_name",
            placeholder: "Insira o nome da firma",
            name: "nomeFirma",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 50,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        3: {
          designacao: {
            id: 3,
            title: "Designação comercial do estabelecimento",
            keyName: "name",
            placeholder: "Insira a designação comercial do estabelecimento",
            name: "designacao",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 200,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        4: {
          morada: {
            id: 4,
            title: "Morada do estabelecimento",
            keyName: "address",
            placeholder: "Insira a morada do estabelecimento",
            name: "morada",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 200,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        5: {
          localidade: {
            id: 5,
            title: "Localidade",
            placeholder: "Insira a localidade",
            keyName: "localidade",
            name: "localidade",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        6: {
          codigoPostal: {
            id: 6,
            title: "Código Postal",
            placeholder: "Insira o código postal",
            keyName: "codigoPostal",
            name: "codigoPostal",
            type: "text",
            required: true,
            value: null,
            min: 4,
            max: 10,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        7: {
          telefone: {
            id: 7,
            title: "Telefone",
            keyName: "contact",
            placeholder: "Insira o número de telefone",
            type: "number",
            name: "telefone",
            required: true,
            value: null,
            min: 9,
            max: 15,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        8: {
          fax: {
            id: 8,
            title: "Fax",
            keyName: "fax",
            placeholder: "Insira o número de fax",
            name: "fax",
            type: "number",
            required: false,
            value: null,
            min: 9,
            max: 15,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        9: {
          responsavel: {
            id: 9,
            title: "Nome do responsável ou proprietário",
            keyName: "company_owner",
            placeholder: "Insira o nome do responsável ou proprietário",
            name: "responsavel",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        10: {
          naturalidade: {
            id: 10,
            title: "Naturalidade do responsável ou proprietário",
            keyName: "owner_nacionality",
            placeholder: "Insira a naturalidade do responsável ou proprietário",
            name: "naturalidade",
            type: "text",
            required: true,
            value: null,
            min: 3,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        11: {
          estabelecimento: {
            id: 11,
            title: "Possui mais estabelecimentos de restauração?",
            keyName: "has_multiple_restaurants",
            name: "estabelecimento",
            required: false,
            value: "nao",
            isValid: true,
          },
        },
        12: {
          email: {
            id: 12,
            title: "E-mail do responsável",
            keyName: "owner_email",
            placeholder: "Insira o e-mail do responsável",
            name: "email",
            type: "email",
            required: false,
            value: null,
            min: 3,
            max: 40,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        13: {
          telefoneResponsavel: {
            id: 13,
            title: "Telemóvel/Telefone do responsável",
            keyName: "owner_contact",
            placeholder: "Insira o telemóvel/telefone do responsável",
            name: "telefoneResponsavel",
            type: "number",
            required: true,
            value: null,
            min: 9,
            max: 15,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        14: {
          socio: {
            id: 14,
            title: "Associado da AHRESP?",
            keyName: "ahresp_partner",
            name: "socio",
            required: false,
            value: "nao",
            isValid: true,
          },
        },
        15: {
          tipoEstabelecimento: {
            id: 15,
            title: "Tipo de estabelecimento",
            keyName: "typology",
            name: "tipoEstabelecimento",
            required: true,
            error: "",
            message: "",
            isValid: true,
            data: {
              0: {
                id: 3,
                label: t("type_classico"),
                isSelected: false,
              },
              1: {
                id: 4,
                label: t("type_fine_dining"),
                isSelected: false,
              },
              2: {
                id: 5,
                label: t("type_tasca"),
                isSelected: false,
              }
            },
          },
        },
        16: {
          precoMedio: {
            id: 16,
            title: "Preço médio",
            keyName: "price",
            subTitle: " (por pessoa)",
            name: "precoMedio",
            required: false,
            isValid: true,
            data: {
              0: {
                id: 0,
                label: "€",
                isSelected: true,
              },
              1: {
                id: 1,
                label: "€€",
                isSelected: false,
              },
              2: {
                id: 2,
                label: "€€€",
                isSelected: false,
              },
              3: {
                id: 3,
                label: "€€€€",
                isSelected: false,
              },
            },
          },
        },
        17: {
          outrasCaracteristicas: {
            id: 17,
            title: "Outras características do estabelecimento",
            keyName: "features",
            name: "outrasCaracteristicas",
            required: false,
            isValid: "",
            data: {
              0: {
                id: 0,
                label: t("wifi"),
                isSelected: false,
              },
              1: {
                id: 1,
                label: t("baby_chair"),
                isSelected: false,
              },
              2: {
                id: 2,
                label: t("reduced_mob"),
                isSelected: false,
              },
              3: {
                id: 3,
                label: t("reservations"),
                isSelected: false,
              },
              4: {
                id: 4,
                label: t("terrace"),
                isSelected: false,
              },
              5: {
                id: 5,
                label: t("other_caracteristics"),
                isSelected: false,
              },
            },
          },
        },
        18: {
          capacidade: {
            id: 18,
            title: "Capacidade do estabelecimento",
            name: "capacidade",
            required: true,
            isValid: "",
            error: false,
            message: "",
            data: {
              totalInside: {
                label: "Nº total de lugares no interior",
                name: "totalInside",
                number: null,
                keyName: "interior_capacity",
              },
              totalOutside: {
                label: "Nº total de lugares na esplanada",
                name: "totalOutside",
                number: null,
                keyName: "exterior_capacity",
              },
            },
          },
        },
        19: {
          horario: {
            id: 19,
            title: "Horário",
            name: "horario",
            required: true,
            isValid: "",
            error: "",
            message: "",
            days: [
              { id: 0, value: "domingo", label: t("Domingo") },
              { id: 1, value: "segunda", label: t("Segunda") },
              { id: 2, value: "terca", label: t("Terça") },
              { id: 3, value: "quarta", label: t("Quarta") },
              { id: 4, value: "quinta", label: t("Quinta") },
              { id: 5, value: "sexta", label: t("Sexta") },
              { id: 6, value: "sabado", label: t("Sábado") },
              { id: 7, value: "feriados", label: t("Feriados") },
            ],
            data: [
              {
                days: [],
                timeOpen: moment().startOf("day"),
                timeClose: moment().startOf("day"),
                isValidArray: [false, true, true],
              },
            ],
          },
        },
        20: {
          pratosPortugueses: {
            id: 20,
            title:
              "Pratos inspirados na gastronomia portuguesa disponibilizados na carta/menu",
            subTitle: " (indicar os 5 mais caracteristicos)",
            name: "pratosPortugueses",
            required: true,
            error: "",
            message: "",
            isValid: "",
            data: {
              0: {
                name: "",
                isValid: "",
              },
              1: {
                name: "",
                isValid: "",
              },
              2: {
                name: "",
                isValid: "",
              },
              3: {
                name: "",
                isValid: "",
              },
              4: {
                name: "",
                isValid: "",
              },
            },
          },
        },
        21: {
          produtosPortugueses: {
            id: 21,
            title: "Produtos portugueses utilizados",
            subTitle: " (indicar os 10 mais característicos)",
            name: "produtosPortugueses",
            required: false,
            value: [],
            error: "",
            message: "",
            isValid: "",
          },
        },
        22: {
          website: {
            id: 22,
            title: "Website",
            keyName: "website",
            placeholder: "Insira o link do website do estabelecimento",
            name: "website",
            type: "text",
            required: false,
            value: null,
            min: 9,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        23: {
          facebook: {
            id: 23,
            title: "Redes sociais do estabelecimento",
            keyName: "social_fb",
            placeholder: "Insira o link do facebook",
            name: "facebook",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        24: {
          instagram: {
            id: 24,
            title: null,
            keyName: "social_ig",
            placeholder: "Insira o link do instagram",
            name: "instagram",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        25: {
          twitter: {
            id: 25,
            title: null,
            keyName: "social_tw",
            placeholder: "Insira o link do twitter",
            name: "twitter",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        26: {
          sobre: {
            id: 26,
            title: "Sobre o estabelecimento",
            keyName: "about",
            placeholder: "Insira uma pequena descrição sobre o estabelecimento",
            name: "sobre",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 300,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        27: {
          tipoOutro: {
            id: 27,
            title: null,
            placeholder: "Insira outro tipo de estabelecimento",
            keyName: "typology_other",
            name: "tipoOutro",
            type: "text",
            required: false,
            value: null,
            min: 3,
            max: 50,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        28: {
          outrasOutro: {
            id: 28,
            title: null,
            placeholder: "Insira outras caracteristicas do estabelecimento",
            keyName: "feature_other",
            name: "outrasOutro",
            type: "text",
            required: false,
            value: null,
            min: 6,
            max: 100,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        29: {
          emailEstabelecimento: {
            id: 29,
            title: "E-mail do estabelecimento",
            keyName: "establishment_email",
            placeholder: "Insira o e-mail do estabelecimento",
            name: "emailEstabelecimento",
            type: "email",
            required: true,
            value: null,
            min: 3,
            max: 40,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        30: {
          maisEstabelecimentos: {
            id: 30,
            title:
              "Designação comercial do(s) outro(s) estabelecimento(s) e cidade onde se situa",
            keyName: "establishment_more",
            placeholder:
              "Insira a designação comercial do(s) outro(s) estabelecimento(s) e cidade onde se situa",
            name: "maisEstabelecimentos",
            type: "text",
            required: false,
            value: null,
            min: 3,
            max: 300,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
        31: {
          ahresp_partner_number: {
            id: 31,
            title: "Número de associado da AHRESP",
            keyName: "ahresp_partner_number",
            placeholder: "Insira o número de associado da AHRESP",
            name: "ahresp_partner_number",
            type: "number",
            required: false,
            value: null,
            min: 1,
            max: 20,
            error: "",
            success: "",
            message: "",
            isValid: "",
          },
        },
      },
      toSend: {
        Restaurant: {
          approved: "0",
          name: null,
          fax: null,
          company_name: null,
          company_owner: null,
          owner_nacionality: null,
          owner_email: null,
          owner_contact: null,
          has_multiple_restaurants: 0,
          ahresp_partner: 0,
          ahresp_partner_number: null,
          translationsStrings: {
            "pt-PT": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
            "en-GB": {
              notes: null,
              about: null,
              description: null,
              quote: null,
            },
          },
          network: "1",
          typology: [1],
          meal_types: [],
          interior_capacity: null,
          exterior_capacity: null,
          contact: null,
          price: "1",
          country_id: null,
          city: null,
          address: null,
          coordinates: {
            lat: null,
            lon: null,
          },
          establishment_email: null,
          website: null,
          social_fb: null,
          social_ig: null,
          social_tw: null,
          features: [],
          product_ids: [],
          typology_other: null,
          feature_other: null,
          establishment_more: null,
          images: [],
          urls: [],
        },
        Menu: [
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
          {
            translationsStrings: {
              "pt-PT": {
                name: null,
                ingredients: null,
              },
              "en-GB": {
                name: null,
                ingredients: null,
              },
            },
            price: null,
          },
        ],
        Timetable: [],
      },
      images: [],
      statusSend: 1,
      urls: [],
    });
    document.getElementById("formApply").reset();
  };

  agreementChange() {
    if (this.state.agreement) {
      this.setState({ agreement: false });
    } else {
      this.setState({ agreement: true });
    }
  }

  render() {
    const { status, data, statusSend, isOpen, isOpenError } = this.state;

    const { t } = this.props;

    // const AsyncComponent = Select.AsyncCreatable;

    const classNames = {
      closeButton: "closeButtonDisplay",
      closeIcon: "closeButtonDisplay",
    };

    return (
      <ApplyPage id="applyPage">
        <BannerTop t={t} type={6} title={t("candidatura")} />
        <Space></Space>
        {status === 0 && (
          <LoadingContent>
            <Loading />
          </LoadingContent>
        )}
        {status === 1 && (
          <Container>
            <Content>
              <RightContent>
                <TitleForm>{t("BoletimTitle")}</TitleForm>
                <form id="formApply">
                  <Row>
                    {/* PAÍS */}
                    <Col md={6} className="overflow">
                      <SelectContent>
                        <Title>
                          {/* {t("apply_country_title")} */}
                          {data[0].pais.title}
                          {data[0].pais.required && "*"}
                        </Title>
                        <Select
                          options={data[0].pais.data}
                          clearable={false}
                          name="selected-country"
                          value={data[0].pais.value}
                          onChange={this.selectedCountry}
                          searchable={this.state.searchable}
                          placeholder={t("apply_country_placeholder")}
                          autoBlur={false}
                        />
                        {data[0].pais.error && (
                          <Error>{data[0].pais.message}</Error>
                        )}
                      </SelectContent>
                    </Col>

                    {/* CIDADE */}
                    <Col md={6} className="overflow">
                      <SelectContent>
                        <Title>
                          {t("apply_city_title")}
                          {data[1].cidade.required && "*"}
                        </Title>
                        <Select
                          options={data[1].cidade.data}
                          disabled={data[0].pais.value != null ? false : true}
                          simpleValue
                          clearable={true}
                          name="selected-city"
                          value={data[1].cidade.value}
                          onChange={this.selectCity}
                          searchable={this.state.searchable}
                          placeholder={t("apply_city_placeholder")}
                          autoBlur={false}
                        />
                        {data[1].cidade.error && (
                          <Error>{data[1].cidade.message}</Error>
                        )}
                      </SelectContent>
                    </Col>
                  </Row>

                  {/* SECTION 2 */}
                  <SubTitleForm>{t("apply_identification_title")}</SubTitleForm>
                  <Row>
                    {/* NOME DA FIRMA */}
                    <Col md={12}>
                      <Input
                        id={data[2].nomeFirma.id}
                        name={data[2].nomeFirma.name}
                        keyName={data[2].nomeFirma.keyName}
                        type={data[2].nomeFirma.type}
                        title={t("apply_firm_title")}
                        placeholder={t("apply_firm_placeholder")}
                        required={data[2].nomeFirma.required}
                        min={data[2].nomeFirma.min}
                        max={data[2].nomeFirma.max}
                        error={data[2].nomeFirma.error}
                        success={data[2].nomeFirma.success}
                        message={data[2].nomeFirma.message}
                        onBlur={this.onBlurValidateTextNumber}
                      />
                    </Col>

                    {/* DESIGNAÇÃO COMERCIAL DO RESTAURANTE */}
                    <Col md={12}>
                      <Input
                        id={data[3].designacao.id}
                        name={data[3].designacao.name}
                        keyName={data[3].designacao.keyName}
                        type={data[3].designacao.type}
                        title={t("apply_designation_title")}
                        placeholder={t("apply_designation_placeholder")}
                        required={data[3].designacao.required}
                        min={data[3].designacao.min}
                        max={data[3].designacao.max}
                        error={data[3].designacao.error}
                        success={data[3].designacao.success}
                        message={data[3].designacao.message}
                        onBlur={this.onBlurValidateTextNumber}
                      />
                    </Col>

                    {/* MORADA */}
                    <Col md={12}>
                      <Input
                        id={data[4].morada.id}
                        name={data[4].morada.name}
                        keyName={data[4].morada.keyName}
                        type={data[4].morada.type}
                        title={t("apply_address_title")}
                        placeholder={t("apply_address_placeholder")}
                        required={data[4].morada.required}
                        min={data[4].morada.min}
                        max={data[4].morada.max}
                        error={data[4].morada.error}
                        success={data[4].morada.success}
                        message={data[4].morada.message}
                        onBlur={this.onBlurValidateSpecialChars}
                      />
                    </Col>

                    {/* LOCALIDADE */}
                    <Col md={8}>
                      <Input
                        id={data[5].localidade.id}
                        name={data[5].localidade.name}
                        type={data[5].localidade.type}
                        title={t("apply_local_title")}
                        placeholder={t("apply_local_placeholder")}
                        required={data[5].localidade.required}
                        min={data[5].localidade.min}
                        max={data[5].localidade.max}
                        error={data[5].localidade.error}
                        success={data[5].localidade.success}
                        message={data[5].localidade.message}
                        onBlur={this.onBlurValidateOnlyText}
                      />
                    </Col>

                    {/* CÓDIGO POSTAL */}
                    <Col md={4}>
                      <Input
                        id={data[6].codigoPostal.id}
                        name={data[6].codigoPostal.name}
                        type={data[6].codigoPostal.type}
                        title={t("apply_zipcode_title")}
                        placeholder={t("apply_zipcode_placeholder")}
                        required={data[6].codigoPostal.required}
                        min={data[6].codigoPostal.min}
                        max={data[6].codigoPostal.max}
                        error={data[6].codigoPostal.error}
                        success={data[6].codigoPostal.success}
                        message={data[6].codigoPostal.message}
                        onBlur={this.onBlurValidadeCodeZip}
                      />
                    </Col>

                    {/* TELEFONE */}
                    {/* <Input
                        id={data[7].telefone.id}
                        name={data[7].telefone.name}
                        keyName={data[7].telefone.keyName}
                        type={data[7].telefone.type}
                        title={t("apply_phone_title")}
                        placeholder={t("apply_phone_placeholder")}
                        required={data[7].telefone.required}
                        min={data[7].telefone.min}
                        max={data[7].telefone.max}
                        error={data[7].telefone.error}
                        success={data[7].telefone.success}
                        message={data[7].telefone.message}
                        onBlur={this.onBlurValidadeNumber}
                      /> */}

                    <ColumnPhone>
                      <PhoneInputLabel>Telefone/Telemóvel</PhoneInputLabel>
                      <PhoneInput
                        placeholder={t("apply_phone_placeholder")}
                        inputProps={{
                          name: data[7].telefone.name,
                          required: true,
                        }}
                        onChange={(e) => this.onChangePhone(e)}

                      // You can add other props and event handlers as needed
                      />
                      {data[7].telefone.error && (
                        <PhoneInputErrorMessage>
                          {data[7].telefone.message}
                        </PhoneInputErrorMessage>
                      )}
                    </ColumnPhone>

                    {/* FAX */}
                    <Col md={6}>
                      <Input
                        id={data[8].fax.id}
                        name={data[8].fax.name}
                        keyName={data[8].fax.keyName}
                        type={data[8].fax.type}
                        title={t("apply_fax_title")}
                        placeholder={t("apply_fax_placeholder")}
                        required={data[8].fax.required}
                        min={data[8].fax.min}
                        max={data[8].fax.max}
                        error={data[8].fax.error}
                        success={data[8].fax.success}
                        message={data[8].fax.message}
                        onBlur={this.onBlurValidadeNumber}
                      />
                    </Col>

                    {/* NOME DO RESPONSAVEL OU PROPRIETÁRIO  */}
                    <Col md={12}>
                      <Input
                        id={data[9].responsavel.id}
                        name={data[9].responsavel.name}
                        keyName={data[9].responsavel.keyName}
                        type={data[9].responsavel.type}
                        title={t("apply_responsible_title")}
                        placeholder={t("apply_responsible_placeholder")}
                        required={data[9].responsavel.required}
                        min={data[9].responsavel.min}
                        max={data[9].responsavel.max}
                        error={data[9].responsavel.error}
                        success={data[9].responsavel.success}
                        message={data[9].responsavel.message}
                        onBlur={this.onBlurValidateOnlyText}
                      />
                    </Col>

                    {/* NATURALIDADE RESPONSAVEL OU PROPRIETÁRIO  */}
                    <Col md={6}>
                      <Input
                        id={data[10].naturalidade.id}
                        name={data[10].naturalidade.name}
                        keyName={data[10].naturalidade.keyName}
                        type={data[10].naturalidade.type}
                        title={t("apply_naturality_title")}
                        placeholder={t("apply_naturality_placeholder")}
                        required={data[10].naturalidade.required}
                        min={data[10].naturalidade.min}
                        max={data[10].naturalidade.max}
                        error={data[10].naturalidade.error}
                        success={data[10].naturalidade.success}
                        message={data[10].naturalidade.message}
                        onBlur={this.onBlurValidateOnlyText}
                      />
                    </Col>

                    {/* POSSUI MAIS ESTABELECIMENTOS DE RESTAURAÇÃO  */}
                    <Col md={6}>
                      <Radio
                        title={t("apply_establishment_title")}
                        required={data[11].estabelecimento.required}
                        value={data[11].estabelecimento.value}
                        onChange={this.onChangeEstablishment}
                        t={t}
                      />
                    </Col>

                    {/* MAIS ESTABELECIMENTOS OPTION */}
                    {data[11].estabelecimento.value === "sim" && (
                      <Col md={12}>
                        <MoreRow>
                          <Row>
                            <Col md={12}>
                              <TextArea
                                to="1"
                                id={data[30].maisEstabelecimentos.id}
                                name={data[30].maisEstabelecimentos.name}
                                keyName={data[30].maisEstabelecimentos.keyName}
                                type={data[30].maisEstabelecimentos.type}
                                title={t("apply_more_establishments_title")}
                                placeholder={t(
                                  "apply_more_establishments_placeholder"
                                )}
                                required={
                                  data[30].maisEstabelecimentos.required
                                }
                                min={data[30].maisEstabelecimentos.min}
                                max={data[30].maisEstabelecimentos.max}
                                error={data[30].maisEstabelecimentos.error}
                                success={data[30].maisEstabelecimentos.success}
                                message={data[30].maisEstabelecimentos.message}
                                onBlur={this.onBlurValidateTextNumber}
                              />
                            </Col>
                          </Row>
                        </MoreRow>
                      </Col>
                    )}

                    {/* EMAIL DO RESPONSAVEL  */}
                    <Col md={6}>
                      <Input
                        id={data[12].email.id}
                        name={data[12].email.name}
                        keyName={data[12].email.keyName}
                        type={data[12].email.type}
                        title={t("apply_email_title")}
                        placeholder={t("apply_email_placeholder")}
                        required={data[12].email.required}
                        min={data[12].email.min}
                        max={data[12].email.max}
                        error={data[12].email.error}
                        success={data[12].email.success}
                        message={data[12].email.message}
                        onBlur={this.onBlurValidadeEmail}
                      />
                    </Col>

                    {/* <Col md={6}>
                      <Input
                        id={data[13].telefoneResponsavel.id}
                        name={data[13].telefoneResponsavel.name}
                        keyName={data[13].telefoneResponsavel.keyName}
                        type={data[13].telefoneResponsavel.type}
                        title={t("apply_responsible_phone_title")}
                        placeholder={t("apply_responsible_phone_placeholder")}
                        required={data[13].telefoneResponsavel.required}
                        min={data[13].telefoneResponsavel.min}
                        max={data[13].telefoneResponsavel.max}
                        error={data[13].telefoneResponsavel.error}
                        success={data[13].telefoneResponsavel.success}
                        message={data[13].telefoneResponsavel.message}
                        onBlur={this.onBlurValidadeNumber}
                      />
                    </Col> */}

                    {/* TELEMOVEL / TELEFONE DO RESPONSAVEL */}
                    <ColumnPhone>
                      <PhoneInputLabel>
                        Telefone/Telemóvel do Responsável
                      </PhoneInputLabel>
                      <PhoneInput
                        placeholder={t("apply_responsible_phone_placeholder")}
                        inputProps={{
                          name: data[13].telefoneResponsavel.name,
                          required: true,
                        }}
                        onChange={(e) => this.onChangePhoneResponsible(e)}

                      // You can add other props and event handlers as needed
                      />
                      {data[13].telefoneResponsavel.error && (
                        <PhoneInputErrorMessage>
                          {data[13].telefoneResponsavel.message}
                        </PhoneInputErrorMessage>
                      )}
                    </ColumnPhone>

                    {/* EMAIL DO ESTABELECIMENTO  */}
                    <Col md={6}>
                      <Input
                        id={data[29].emailEstabelecimento.id}
                        name={data[29].emailEstabelecimento.name}
                        keyName={data[29].emailEstabelecimento.keyName}
                        type={data[29].emailEstabelecimento.type}
                        title={t("apply_establishment_email_title")}
                        placeholder={t("apply_establishment_email_placeholder")}
                        required={data[29].emailEstabelecimento.required}
                        min={data[29].emailEstabelecimento.min}
                        max={data[29].emailEstabelecimento.max}
                        error={data[29].emailEstabelecimento.error}
                        success={data[29].emailEstabelecimento.success}
                        message={data[29].emailEstabelecimento.message}
                        onBlur={this.onBlurValidadeEmail}
                      />
                    </Col>
                  </Row>

                  {/* SECTION 3 */}
                  <SubTitleForm>
                    {t("apply_info_establishment_title")}
                  </SubTitleForm>
                  <Row>
                    {/* SOBRE */}
                    <Col md={12}>
                      <TextArea
                        to="1"
                        id={data[26].sobre.id}
                        keyName={data[26].sobre.keyName}
                        name={data[26].sobre.name}
                        type={data[26].sobre.type}
                        title={t("apply_about_title")}
                        placeholder={t("apply_about_placeholder")}
                        required={data[26].sobre.required}
                        min={data[26].sobre.min}
                        max={data[26].sobre.max}
                        error={data[26].sobre.error}
                        success={data[26].sobre.success}
                        message={data[26].sobre.message}
                        onBlur={this.onBlurValidateString}
                      />
                    </Col>

                    {/* TIPO DE ESTABELECIMENTO */}
                    <Col md={12}>
                      <Title>
                        {t("apply_tipology_title")}
                        {data[15].tipoEstabelecimento.required && " *"}
                      </Title>
                      <ContentBlock>
                        {Object.values(data[15].tipoEstabelecimento.data).map(
                          (item, index) => {
                            return (
                              <CheckBoxItem key={index}>
                                <div>
                                  <CheckBox
                                    value={item.isSelected}
                                    onChange={(id) =>
                                      this.typeEstablishment(index)
                                    }
                                  />
                                </div>
                                <div>{item.label}</div>
                              </CheckBoxItem>
                            );
                          }
                        )}
                        {data[15].tipoEstabelecimento.error && (
                          <Error>{data[15].tipoEstabelecimento.message}</Error>
                        )}
                      </ContentBlock>
                    </Col>

                    {/* TIPO DE ESTABELECIMENTO => OUTRO */}
                    {/* {data[15].tipoEstabelecimento.data[3].isSelected && (
                      <Col md={12} className="overflow">
                        <Other
                          id={data[27].tipoOutro.id}
                          name={data[27].tipoOutro.name}
                          keyName={data[27].tipoOutro.keyName}
                          type={data[27].tipoOutro.type}
                          title={t("apply_typology_other_title")}
                          placeholder={t("apply_typology_other_placeholder")}
                          required={data[27].tipoOutro.required}
                          min={data[27].tipoOutro.min}
                          max={data[27].tipoOutro.max}
                          error={data[27].tipoOutro.error}
                          success={data[27].tipoOutro.success}
                          message={data[27].tipoOutro.message}
                          onBlur={this.onBlurValidateOnlyText}
                        />
                      </Col>
                    )} */}

                    {/* OUTRAS CARACTERISTICAS */}
                    <Col md={12}>
                      <Title>
                        {t("apply_other_caracteristics_title")}
                        {data[17].outrasCaracteristicas.required && " *"}
                      </Title>
                      <ContentBlock>
                        {Object.values(data[17].outrasCaracteristicas.data).map(
                          (item, index) => {
                            return (
                              <CheckBoxItem key={index}>
                                <div>
                                  <CheckBox
                                    value={item.isSelected}
                                    onChange={(id) => this.otherFeatures(index)}
                                  />
                                </div>
                                <div>{item.label}</div>
                              </CheckBoxItem>
                            );
                          }
                        )}
                      </ContentBlock>
                    </Col>

                    {/* OUTRAS CARACTERISTICAS => OUTRO */}
                    {data[17].outrasCaracteristicas.data[5].isSelected && (
                      <Col md={12} className="overflow">
                        <Other
                          id={data[28].outrasOutro.id}
                          name={data[28].outrasOutro.name}
                          keyName={data[28].outrasOutro.keyName}
                          type={data[28].outrasOutro.type}
                          title={t("apply_other_caracteristics_others_title")}
                          placeholder={t(
                            "apply_other_caracteristics_others_placeholder"
                          )}
                          required={data[28].outrasOutro.required}
                          min={data[28].outrasOutro.min}
                          max={data[28].outrasOutro.max}
                          error={data[28].outrasOutro.error}
                          success={data[28].outrasOutro.success}
                          message={data[28].outrasOutro.message}
                          onBlur={this.onBlurValidateOnlyText}
                        />
                      </Col>
                    )}

                    {/* CAPACIDADE */}
                    <Col md={12}>
                      <Title>
                        {t("apply_capacity_title")}
                        {data[18].capacidade.required && " *"}
                      </Title>
                      <ContentBlock>
                        <Row>
                          <Col md={6}>
                            <Numbers>
                              <div>{t("apply_interior_capacity_label")}</div>
                              <input
                                type="number"
                                placeholder={0}
                                onBlur={(event, to) =>
                                  this.defineNumber(event, 0)
                                }
                                min="0"
                                max="10000"
                              />
                            </Numbers>
                            {data[18].capacidade.error && (
                              <Error>{data[18].capacidade.message}</Error>
                            )}
                          </Col>
                          {data[17].outrasCaracteristicas.data[4]
                            .isSelected && (
                              <Col md={6}>
                                <Numbers>
                                  <div>{t("apply_exterior_capacity_label")}</div>
                                  <input
                                    type="number"
                                    placeholder={0}
                                    onBlur={(event, to) =>
                                      this.defineNumber(event, 1)
                                    }
                                    min="0"
                                    max="10000"
                                  />
                                </Numbers>
                              </Col>
                            )}
                        </Row>
                      </ContentBlock>
                    </Col>

                    {/* HORÁRIO */}
                    <Col md={12} className="overflow">
                      <Title>{t("apply_schedule_title")} *</Title>
                      <ContentBlock>
                        {this.renderShedule()}
                        {data[19].horario.error && (
                          <Error>{data[19].horario.message}</Error>
                        )}
                        <HorarioAdd onClick={this.addShedule}>
                          + {t("apply_add_shedule_label")}{" "}
                        </HorarioAdd>
                        <HorarioNote>{t("apply_add_shedule_note")}</HorarioNote>
                      </ContentBlock>
                    </Col>

                    {/* PRATOS */}
                    <Col md={12}>
                      <Title>
                        {t("apply_portuguese_plates_title")}
                        <span>{t("apply_portuguese_plates_subtitle")}</span>
                        {data[20].pratosPortugueses.required && " *"}
                      </Title>
                      <ContentBlock>
                        <List>
                          {Object.values(data[20].pratosPortugueses.data).map(
                            (item, index) => {
                              return (
                                <ListRow key={index}>
                                  <ListNumber>{index + 1}</ListNumber>
                                  <ListText>
                                    <input
                                      type="text"
                                      onBlur={(event, _index) =>
                                        this.defineDish(event, index)
                                      }
                                    />
                                  </ListText>
                                </ListRow>
                              );
                            }
                          )}
                        </List>
                        {data[20].pratosPortugueses.error && (
                          <Error>{data[20].pratosPortugueses.message}</Error>
                        )}
                      </ContentBlock>
                    </Col>

                    {/* UPLOAD IMAGES */}
                    <Col md={12} className="overflow mt-5">
                      <FileUploader
                        title={t("apply_upload_title")}
                        addImages={this.addImages}
                        images={this.state.images}
                        t={t}
                      />
                      <UploadLegend>{t("apply_upload_legend")}</UploadLegend>
                    </Col>

                    {/* VIDEOS */}
                    <Col md={12}>
                      <Videos
                        title={t("apply_videos_title")}
                        placeholder={t("apply_videos_placeholder")}
                        getValuesUrls={this.getUrls}
                        urls={this.state.urls}
                        t={t}
                      />
                    </Col>

                    <RulesContent>
                      <RulesText>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={AgreementDoc}
                        >
                          {t("apply_consent_label")}
                        </a>
                      </RulesText>
                      <RulesText>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={RulesDoc}
                        >
                          {t("apply_program_label")}
                        </a>
                      </RulesText>

                      <RulesText>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={politicPTDOC}
                        >
                          {t("privacy_policy_data_protected")}
                        </a>
                      </RulesText>

                      <RulesCheckBox>
                        <div>
                          <CheckBox onChange={() => this.agreementChange()} />
                        </div>
                        <div>{t("apply_declare_label")}</div>
                      </RulesCheckBox>
                    </RulesContent>

                    <Col md={12}>
                      <RequiredFilds>
                        * - {t("apply_mandatory_fields_label")}
                      </RequiredFilds>
                    </Col>

                    {/* SUBMETER */}
                    <BtnContent>
                      {this.state.agreement && (
                        <BtnSubmit onClick={this.onFormSubmit}>
                          {t("apply_submit_form_label")}
                        </BtnSubmit>
                      )}
                      {!this.state.agreement && (
                        <BtnSubmit disabled>
                          {t("apply_submit_form_label")}
                        </BtnSubmit>
                      )}
                    </BtnContent>
                  </Row>
                </form>
              </RightContent>
            </Content>
          </Container>
        )}
        {status === 2 && <FormError>{t("apply_wrong_submission")}</FormError>}
        <Modal
          open={isOpen}
          little
          classNames={classNames}
          onClose={this.closeModal}
        >
          <ModalContent>
            <StatusContent>
              {statusSend === 0 && <Loading />}
              {statusSend === 1 && <Loading />}
              {statusSend === 2 && (
                <ModalIconSuc>
                  <MdCheck />
                </ModalIconSuc>
              )}
              {statusSend === 3 && (
                <ModalIconErr>
                  <MdClear />
                </ModalIconErr>
              )}
              {statusSend === 4 && (
                <ModalIconErr>
                  <MdErrorOutline />
                </ModalIconErr>
              )}
            </StatusContent>
            <TitleModal>
              {statusSend === 0 && t("apply_sending_form")}
              {statusSend === 1 && t("apply_sending_form")}
              {statusSend === 2 && t("apply_success_form")}
              {statusSend === 3 && t("apply_error_send_form")}
              {statusSend === 4 && t("apply_error_form")}
            </TitleModal>
            <TextModal>
              {statusSend === 0 && t("apply_email_form")}
              {statusSend === 1 && t("apply_email_form")}
              {statusSend === 2 && t("apply_email_form")}
              {statusSend === 3 && t("apply_try_form")}
              {statusSend === 4 && t("apply_error_fields_form")}
            </TextModal>
          </ModalContent>
        </Modal>

        <Modal
          open={isOpenError}
          little
          onClose={this.closeModalError}
          closeIconSize={16}
        >
          <ModalContent>
            <StatusContent>
              <ModalIconErr>
                <MdClear />
              </ModalIconErr>
            </StatusContent>
            <TitleModal>{t("apply_issue_label")}</TitleModal>
            <TextModal>{t("apply_please_contact_label")}</TextModal>
          </ModalContent>
        </Modal>
      </ApplyPage>
    );
  }
}

export default translate("translations")(Apply);

/**
 *
 * PHONE INPUT
 *
 */

const ColumnPhone = styled.div`
  flex: 0 0 50%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;

  input {
    border-radius: 3px;
    border: 1px solid #e6ebec;
    color: #545454;
    font-family: "PT Sans";
    font-size: 14px;
    line-height: 18px;
  }
`;

const PhoneInputLabel = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 8px;
`;

const PhoneInputErrorMessage = styled.div`
  font-family: "PT Sans";
  font-size: 12px;
  color: red;
  opacity: 0.6;
  font-weight: 600;
  margin-top: 3px;
`;

/**
 *
 * UPLOAD
 *
 */

const UploadLegend = styled.p`
  font-size: 11px;
  color: #333;
  line-height: 18px;
  margin-top: -15px;
  margin-bottom: 25px;
  display: flex;
  width: 100%;
`;

const RequiredFilds = styled.div`
  font-size: 13px;
  margin-top: 20px;
  color: hsl(0, 0%, 45%);
  margin-top: 15px;
  font-weight: 600;
`;
const FormError = styled.div`
  text-align: center;
  font-size: 13px;
  margin-top: 20px;
  color: hsl(0, 0%, 45%);
  margin-top: 15px;
  font-weight: 600;
  margin-bottom: 100px;
`;

// STYLES
const Space = styled.div`
  width: 100%;
  height: 80px;
`;
const ApplyPage = styled.div``;
const Content = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  @media screen and (max-width: 992px) {
    display: block;
  }
`;

// LOADING
const LoadingContent = styled.div`
  height: 50vh;
`;

// RIGHT
const RightContent = styled.div`
  width: 67%;

  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;
const TitleForm = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 30px;
  margin-top: -2px;
  margin-bottom: 25px;
`;
const SubTitleForm = styled.div`
  color: #11837b;
  font-family: "PT Sans";
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 25px;
  margin-top: 20px;
`;
const Title = styled.div`
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  margin-bottom: 8px;

  span {
    font-weight: 400;
  }
`;
const ContentBlock = styled.div`
  margin-bottom: 35px;
`;

/**
 *  CHECKBOX
 */

const CheckBoxItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  &:first-child {
    margin-top: 15px;
  }

  &:last-child {
    margin-bottom: 0px;
  }

  div {
    font-size: 14px;
    color: hsl(0, 0%, 17%);
  }
`;
// NUMBERS
const Numbers = styled.div`
  display: flex;
  align-items: center;

  div {
    font-size: 14px;
    margin-right: 10px;
  }

  input {
    width: 50px;
    color: #545454;
    font-family: "PT Sans";
    font-size: 14px;
    line-height: 18px;
    padding: 10px 8px;
    border-radius: 3px;
    border: 1px solid #e6ebec;
    outline: none;
    transition: all 0.3s ease;

    &:focus {
      border: 1px solid ${Colors.primary};
    }
  }
`;

/**
 * LIST
 */
const List = styled.div`
  border: 1px solid #e6ebec;
  border-radius: 3px;
`;
const ListRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6ebec;

  &:last-child {
    border-bottom: none;
  }
`;
const ListNumber = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  border-right: 1px solid #e6ebec;
  color: #666666;
`;
const ListText = styled.div`
  width: calc(100% - 60px);
  color: #666666;
  padding-left: 10px;
  padding-right: 10px;

  input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 14px;
    color: #666666;
    font-family: "PT Sans";
  }
`;
const BtnContent = styled.div`
  display: flex;
  justify-content: flex-end;
  width: calc(100% - 30px);
  margin-left: 15px;
  margin-right: 15px;
  text-align: right;
  margin-bottom: 50px;
  margin-top: 40px;
`;
const BtnSubmit = styled.div`
  width: 138px;
  color: #fff;
  background-color: ${(props) => (props.disabled ? "grey" : "#11837B")};
  border-radius: 3px;
  padding: 15px 15px;
  cursor: ${(props) => (props.disabled ? "context-menu" : "pointer")};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) =>
    props.disabled ? "grey" : lighten(0.05, Colors.primary)};
  }
`;
/**
 *
 * HORÁRIO
 *
 */

const HorarioRow = styled.div`
  padding: 15px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  border-radius: 3px;
  margin-bottom: 10px;
`;
const HorarioItem = styled.div`
  display: flex;
  align-items: center;
`;
const HorarioSelected = styled.div`
  width: calc(55% - 15px);
  margin-right: 15px;
`;
const HorarioOpen = styled.div`
  width: calc(20% - 10px);
  margin-right: 10px;
`;
const HorarioClose = styled.div`
  width: calc(20% - 10px);
  margin-right: 10px;
`;
const HorarioButton = styled.div`
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  color: ${Colors.secondary};
`;
const HorarioAdd = styled.div`
  max-width: 140px;
  margin-top: 20px;
  font-size: 14px;
  color: ${Colors.primary};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: ${lighten(0.05, Colors.primary)};
  }
`;

const HorarioNote = styled.div`
  font-size: 12px;
  color: #333;
  line-height: 18px;
  margin-top: 10px;
`;

/**
 *
 * MORE
 *
 */

const MoreRow = styled.div`
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.15);
  border-radius: 3px;
  margin-bottom: 25px;
`;
/**
 *
 * ERRO E SUCESSO
 *
 */

const Error = styled.div`
  font-family: "PT Sans";
  font-size: 12px;
  color: red;
  opacity: 0.6;
  font-weight: 600;
  margin-top: 3px;
`;
const SelectContent = styled.div`
  margin-bottom: 25px;
`;

/**
 *
 * MODAL
 *
 */

const ModalContent = styled.div`
  width: 400px;
  padding: 20px;
  text-align: center;
`;
const StatusContent = styled.div`
  width: 100%;
  margin-bottom: 35px;
`;
const TitleModal = styled.div`
  font-size: 18px;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-weight: 600;
`;
const TextModal = styled.div`
  font-size: 14px;
  margin-top: 20px;
  color: hsl(0, 0%, 45%);
  margin-bottom: 15px;
`;
const ModalIconSuc = styled.div`
  font-size: 56px;
  color: ${Colors.primary};
  margin-bottom: -15px;
`;
const ModalIconErr = styled.div`
  font-size: 56px;
  color: red;
  margin-bottom: -15px;
`;
//RULES
const RulesContent = styled.div`
  width: 100%;
  background-color: #f4f6f7;
  border: 1px solid #11837b;
  padding: 10px 20px 20px 20px;
  margin: 15px;
`;

const RulesText = styled.div`
  margin-bottom: 10px;
  font-family: "PT Sans";
  a {
    font-size: 14px;
    color: #11837b;
    cursor: pointer;
  }
`;

const RulesCheckBox = styled.div`
  display: flex;
  align-items: center;
  margin-top: 30px;
  font-family: "PT Sans";
  &:first-child {
    margin-top: 15px;
  }

  &:last-child {
    margin-bottom: 0px;
  }

  div {
    font-size: 14px;
    color: hsl(0, 0%, 17%);
  }

  span {
    border: 1px solid #11837b;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/apply/apply.page.js